import { useEffect } from "react"
import { useLocation, useNavigate } from "react-router-dom"
import { isLoggedIn, useAuth } from "./use-auth.jsx"
import { isStandalone } from "../config/ppAiConfig"

export default function useRequireAuth(redirectUrl = "/loginpage") {
    const auth = useAuth()
    const navigate = useNavigate()
    const location = useLocation()

    useEffect(() => {
        if (!isLoggedIn(auth.login) && !isStandalone() && location.pathname !== redirectUrl) {
            try {
                navigate(redirectUrl)
            } catch {
                // In iframe/unsicherer Umgebung kann history.push fehlschlagen
            }
        }
    }, [auth.login, redirectUrl, location.pathname, navigate])

    return auth
}
